// src/firebase.ts
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import {
    initializeFirestore,
    persistentLocalCache,
    persistentMultipleTabManager,
    persistentSingleTabManager,
    memoryLocalCache,
    connectFirestoreEmulator,
    CACHE_SIZE_UNLIMITED,
    Firestore,
} from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCTHC92jtpuRvRloCQedNwibo7SgS4rvk4",
    authDomain: "chusho-app.firebaseapp.com",
    projectId: "chusho-app",
    storageBucket: "chusho-app.firebasestorage.app",
    messagingSenderId: "681973338389",
    appId: "1:681973338389:web:bea22413257c8a8f99991c",
    measurementId: "G-ZGEF8VKLHY"
};

// Firebase 初期化（すでに初期化されていない場合のみ）
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// Capacitor / SSR / IndexedDB 未対応環境の判定
const isCapacitor = typeof window !== 'undefined' &&
    (window.location.protocol === 'capacitor:' || (window as any).Capacitor?.isNativePlatform?.());
const hasIndexedDB = typeof window !== 'undefined' && typeof window.indexedDB !== 'undefined';

// Firestore を環境に応じて初期化
// Capacitor 環境では persistentMultipleTabManager が初期化失敗するため、フォールバック
// experimentalForceLongPolling は WebSocket が不安定な環境（Capacitor WebView 含む）で有効
let firestoreInstance: Firestore;
try {
    firestoreInstance = initializeFirestore(app, {
        localCache: isCapacitor || !hasIndexedDB
            ? memoryLocalCache()
            : persistentLocalCache({
                tabManager: persistentMultipleTabManager(),
                cacheSizeBytes: CACHE_SIZE_UNLIMITED,
            }),
        experimentalForceLongPolling: isCapacitor,
    } as any);
} catch (err) {
    console.warn('[firebase] Falling back to memory cache due to init error:', err);
    firestoreInstance = initializeFirestore(app, {
        localCache: memoryLocalCache(),
        experimentalForceLongPolling: true,
    } as any);
}
export const db = firestoreInstance;

export const storage = getStorage(app);

// ローカルエミュレータ接続（開発用）
// エミュレータを使用する場合はコメントを解除
// if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.startsWith("192.168.")) {
//     // Firestoreエミュレータ接続
//     connectFirestoreEmulator(db, 'localhost', 7779);

//     // Authエミュレータ接続
//     connectAuthEmulator(auth, "http://localhost:9099");

//     // Storageエミュレータ接続
//     connectStorageEmulator(storage, "localhost", 9190);
// }

// これでローカルで起動したエミュレータに接続され、Firebase関連の操作がローカル環境でテスト可能になります。
